import React, { useState, useEffect } from 'react';
import { Select, Table, Form } from 'antd';
import { cloneDeep } from 'lodash';

interface PropsType {
  value?: any;
  onChange?: any;
  enums?: any;
}

const ItemContent:React.FC<PropsType> = (props) => {
  const { enums, value, onChange } = props || {};

  const { f_rule_hours_limit } = enums || {};

  const [dataSource, setDataSource] = useState<any>([]);

  const columns = [
    {
      title: '零散小时N',
      dataIndex: 'hour',
    },
    {
      title: '租车费用',
      dataIndex: 'expense',
    },
  ];

  const handleHourChange = (value: number) => {
    onChange && onChange(value);
  }

  useEffect(() => {
    const hours = new Array(value || 0).fill({});
    hours.forEach((item: any, index: number) => {
      const newItem = cloneDeep(item);
      newItem.id = index;
      newItem.hour = index === hours.length - 1 ? `在${index}-${index + 1}小时及≥${index + 1}小时` : `在${index}-${index + 1}小时内（含）`;
      newItem.expense = `零散小时费收取当日日租金比例：${index + 1}/${value}（即：${((index + 1 )/ value * 100).toFixed(2)}%）`;
      hours[index] = newItem;
    });
    setDataSource(hours);
  }, [value]);


  return (
    <div style={{ marginLeft: '12px' }}>
      <div style={{ lineHeight: '32px', color: 'rgb(255, 100, 0)' }}>租期小于24小时，按整天收费</div>
      <div style={{ display: 'flex', alignItems: 'center' }}>租期大于24小时（X天N小时），N满足
        <Form.Item
          style={{ display: 'inline-block', margin: 0, marginBottom: 0 }}
          name="gt_several_hour"
          rules={[{ required: true, message: "请选择时间" }]}
        >
          <Select
            value={value}
            onChange={handleHourChange}
            style={{ width: '100px', margin: '0 6px' }}
            options={(f_rule_hours_limit || []).map((item: any) => ({ label: item.value, value: item.key }))}
          />
        </Form.Item>
        小时，按一天收费
      </div>
      <Table rowKey="id" columns={columns} dataSource={dataSource} pagination={false} style={{ marginTop: '20px' }} />
    </div>
  )
}

export default ItemContent;